import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Token management - works across any domain
const TOKEN_KEY = "myerba_access_token";

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  }
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
  delete API.defaults.headers.common["Authorization"];
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

// Restore token on load
const storedToken = getStoredToken();
if (storedToken) {
  API.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
}

API.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url.includes("/auth/")) {
      originalRequest._retry = true;
      try {
        const { data } = await API.post("/auth/refresh");
        if (data.access_token) {
          setAuthToken(data.access_token);
          originalRequest.headers["Authorization"] = `Bearer ${data.access_token}`;
        }
        return API(originalRequest);
      } catch {
        clearAuthToken();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function formatError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).filter(Boolean).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default API;
